import React from "react";
import "./Affordable.css";
import AffordImage from "../../../../assets/images/affordable-section.png";
const Affordable = () => {
  return (
    <div className="affordable_section">
      <div className="affordable__section_left">
        <img src={AffordImage} alt="" className="affordable__section_img" />
      </div>
      <div className="affordable__section_right">
        <div className="affordable__secleft_heading">Affordable</div>
        <div className="affordable__secleft_description">
          <p>
            We offer with a quality tax services and ensures clients accurate,
            efficient, state-of-the-art service at a competitive price with most
            returns priced at a reasonable price.We believe in quality and
            remarkable service and keep them affordably available to our
            clients.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Affordable;
